import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { REGEX } from 'src/app/core/validation';

@Directive({
  selector: '[appSsnMask]',
  standalone: true
})
export class SsnMaskDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(REGEX.NON_NUMERIC, ''); // Remove non-numeric characters.

    // Apply formatting: AAA-GG-SSSS
    if (value.length > 3 && value.length <= 5) {
      value = `${value.slice(0, 3)}-${value.slice(3)}`;
    } else if (value.length > 5) {
      value = `${value.slice(0, 3)}-${value.slice(3, 5)}-${value.slice(5, 9)}`;
    }

    // Set the formatted value back to the input.
    this.ngControl.control?.setValue(value);
  }
}
